import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule],
  template: `
    <section class="section login-page">
      <div class="page-title-block login-heading">
        <h1>LOGIN</h1>
        <span class="title-line"></span>
      </div>

      <form class="login-card card accent-card" (ngSubmit)="login()">
        <label>
          <span>Username / Mail</span>
          <input name="username" [(ngModel)]="usernameOrEmail" autocomplete="username" [disabled]="isLoading" />
        </label>

        <label>
          <span>Passwort</span>
          <input name="password" type="password" [(ngModel)]="password" autocomplete="current-password" [disabled]="isLoading" />
        </label>

        @if (errorMessage) {
          <p class="login-error">{{ errorMessage }}</p>
        }

        <button class="button primary" type="submit" [disabled]="isLoading">
          {{ isLoading ? 'Einloggen...' : 'Einloggen' }}
        </button>
      </form>
    </section>
  `
})
export class LoginComponent {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  usernameOrEmail = '';
  password = '';
  isLoading = false;
  errorMessage = '';

  login(): void {
    this.errorMessage = '';

    if (!this.usernameOrEmail.trim() || !this.password.trim()) {
      this.errorMessage = 'Bitte Username/Mail und Passwort eingeben.';
      return;
    }

    this.isLoading = true;

    this.auth.login(this.usernameOrEmail.trim(), this.password)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: () => {
          const target = this.auth.canUseCreatorSpace() ? '/creator-space' : '/';
          this.router.navigateByUrl(target);
        },
        error: () => {
          this.errorMessage = 'Login fehlgeschlagen. Bitte Daten prüfen.';
        }
      });
  }
}
